import { collection, getDocs, getFirestore } from "firebase/firestore";

export const useFirestoreBackup = () => {
  const exportCollectionsToJSON = async (collectionNames: string[]) => {
    const db = getFirestore();
    const dataArray: { collectionName: string; jsonData: string }[] = [];

    for (const collectionName of collectionNames) {
      const colRef = collection(db, collectionName);
      const colSnap = await getDocs(colRef);

      const collectionData: any = {};
      colSnap.forEach((doc) => {
        collectionData[doc.id] = doc.data();
      });

      const jsonData = JSON.stringify(collectionData);
      dataArray.push({ collectionName, jsonData });
    }

    return dataArray;
  };

  return { exportCollectionsToJSON };
};
